import '../../styles/messages.css'
import '../../styles/app.css'

const StaticMessages = (props) => {

    return (
        <div className="message-container">
            <div
                className="bot-message"
                dangerouslySetInnerHTML={{ __html: props.payload.text }}>
            </div>
        </div>
    )
}

export default StaticMessages